export const invoicesExtractor = (invoicesData) => {
  return invoicesData.map((invoice) => {
    return {
      id: invoice?.id,
      oldId: invoice?.attributes?.oldId,
      createdAt: invoice?.attributes?.createdAt,
      // refClient: invoice?.attributes?.order?.data?.attributes?.refClient,
      // realRefClient:
      //   invoice?.attributes?.order?.data?.attributes?.realRefClient,
      type: invoice?.attributes?.type,
      status:
        invoice?.attributes?.type === "facture"
          ? invoice?.attributes?.commande?.data?.attributes?.status
          : invoice?.attributes?.payment?.data?.attributes?.commande?.data
              ?.attributes?.status,
      totalTTC:
        invoice?.attributes?.type === "facture"
          ? invoice?.attributes?.commande?.data?.attributes?.totalTTC
          : invoice?.attributes?.payment?.data?.attributes?.amount,
      orderID: invoice?.attributes?.commande?.data?.id,
      oldIdOrder: invoice?.attributes?.commande?.data?.attributes?.oldId,
      reseller:
        invoice?.attributes?.type === "facture"
          ? invoice?.attributes?.commande?.data?.attributes?.reseller?.data
              ?.attributes.name
          : invoice?.attributes?.payment?.data?.attributes?.commande?.data
              ?.attributes?.reseller?.data?.attributes.name,
      fileUrl: invoice?.attributes?.media?.data?.attributes?.url,
      slug: invoice?.attributes?.number,
      slugDate: invoice?.attributes?.date,
      orderSlug:
        invoice?.attributes?.type === "facture"
          ? invoice?.attributes?.commande?.data?.attributes?.number
          : invoice?.attributes?.payment?.data?.attributes?.commande?.data
              ?.attributes?.number,
    };
  });
};
